<template>
  <div class="app-container activity-party-list">
    <el-tabs v-model="activeName" @tab-click="onTabShow">
      <el-tab-pane label="培训团队" name="subLob">
        <div class="activity-party-list-filter">
          <el-row>
            <el-col :span="6">
              <div class="activity-party-content bg-purple">
                <el-date-picker
                class="activity-party-list-filter-value"
                v-model="searchedSubLobDateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="selectSubLobDate"
                :clearable=false
                size="small">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content-select bg-purple">
                <!-- <el-input class="activity-party-list-filter-value" v-model.trim="searchSubLob.organizedBy" @keyup.enter.native="getSubLobAnalysisSummary" placeholder="培训团队名称" clearable size="small" suffix-icon="el-icon-search"></el-input> -->
                <el-select v-model="searchSubLob.organizedBy" @change="getSubLobAnalysisSummary" filterable clearable size="small" placeholder="培训团队名称">
                  <el-option
                    v-for="item in organizedByOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
            </el-col>
            <el-col :span="6">
              <div>
                <el-button class="activity-party-list-filter-reset" size="small" @click="searchSubLobAnalysisChange">立即筛选</el-button>
                <el-button class="activity-party-list-filter-search" size="small" @click="searchSubLobAnalysisReset">清除条件</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <basic-container>
          <avue-crud
            ref="crud"
            :option="subLobTableOption"
            :data="subLobsList"
            :page="subLobPage"
            :table-loading="subLobsListLoading"
            @refresh-change="getSubLobAnalysisSummary"
            @sort-change="handleSubLobSortChange"
            @current-change="handleSubLobCurrentChange"
            @size-change="handleSubLobSizeChange">
            <template slot="menuLeft">
              <el-button  
                          v-if="permissions.analysis_party_export"
                          class="filter-item"
                          @click="handleSubLobAnalysisExport()"
                          size="small"
                          type="primary"
                          :loading="exportSubLobAnalysisByLoading"
                          icon="el-icon-download">{{exportSubLobAnalysisName}}
              </el-button>
            </template>
          </avue-crud>
        </basic-container>
      </el-tab-pane>

      <el-tab-pane label="培训老师" name="lecturer">
        <div class="activity-party-list-filter">
          <el-row>
            <el-col :span="6">
              <div class="activity-party-content bg-purple">
                <el-date-picker
                class="activity-party-list-filter-value"
                v-model="searchedLecturerDateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="selectLecturerDate"
                :clearable=false
                size="small">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-input class="activity-party-list-filter-value" v-model.trim="search.lecturer" @keyup.enter.native="getLecturerAnalysisSummary" placeholder="培训老师名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-button class="activity-party-list-filter-reset" size="small" @click="searchLecturerAnalysisChange">立即筛选</el-button>
                <el-button class="activity-party-list-filter-search" size="small" @click="searchLecturerAnalysisReset">清除条件</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <basic-container>
          <avue-crud
            ref="crud"
            :option="lecturerTableOption"
            :data="list"
            :page="page"
            :table-loading="listLoading"
            @refresh-change="getLecturerAnalysisSummary"
            @sort-change="handleLecturerSortChange"
            @current-change="handleLecturerCurrentChange"
            @size-change="handleLecturerSizeChange">
            <template slot="menuLeft">
              <el-button 
                          v-if="permissions.analysis_lecture_export"
                          class="filter-item"
                          @click="handleLecturerAnalysisExport()"
                          size="small"
                          type="primary"
                          :loading="exportLecturerAnalysisByLoading"
                          icon="el-icon-download">{{exportLecturerAnalysisName}}
              </el-button>
            </template>
          </avue-crud>
        </basic-container>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {getActivityLecturerStatisticsSummaryData, getActivitySubLobStatisticsSummaryData, exportActivityLecturerStatisticsSummaryData, exportActivitySubLobStatisticsSummaryData} from '@/api/analysis/activityPartyAnalysis'
  import { exporting } from '@/util/exportUtil'
  import {lecturerTableOption, subLobTableOption} from '@/const/crud/analysis/activityPartyAnalysis'
  import { organizedByOptions } from '@/const/crud/app/activity';
  import {getMembersByNickname, getSubLobsByDepartment} from '@/api/admin/member';
  import {mapGetters} from "vuex";

  export default {
    name: "table_member",
    data() {
      return {
        activeName: "subLob",
        exportLecturerAnalysisByLoading: false,
        exportLecturerAnalysisName: "导出",
        exportSubLobAnalysisByLoading: false,
        exportSubLobAnalysisName: "导出",
        subLobsList: [],
        list: [],
        lecturerTableOption: lecturerTableOption,
        subLobTableOption: subLobTableOption,
        listLoading: false,
        subLobsListLoading: false,
        searchedLecturerDateRange: [],
        searchedSubLobDateRange: [],
        search: {
          current: 1,
          size: 10,
          organizedBy: '',
          lecturer: '',
          unionId: '',
          sortField: "",
          sortPolicy: "",
        },
        searchSubLob: {
          current: 1,
          size: 10,
          organizedBy: '',
          sortField: "",
          sortPolicy: "",
        },
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        subLobPage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        lecturers:[],
        subLobList: [],
        dataType: 'total',
        organizedByOptions: organizedByOptions,
      };
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    activated() {
      // this.fetchSubLobList()
      this.getSubLobAnalysisSummary()
    },
    created() {
      // this.fetchSubLobList()
      this.getSubLobAnalysisSummary()
    },
    methods: {
      onTabShow(tab) {
        switch (tab.name) {
          case 'subLob':
            this.getSubLobAnalysisSummary();
          break;
          case 'lecturer':
            this.getLecturerAnalysisSummary();
          break;
        }
      },
      selectLecturerDate(e) {
        var nDays = this.daysBetween(this.searchedLecturerDateRange[0], this.searchedLecturerDateRange[1]);
        if(nDays > 100 && this.dateType != 'total') {
          this.dataType = 'total'
        }
        this.getLecturerAnalysisSummary()
      },
      selectSubLobDate(e) {
        var nDays = this.daysBetween(this.searchedSubLobDateRange[0], this.searchedSubLobDateRange[1]);
        if(nDays > 100 && this.dateType != 'total') {
          this.dataType = 'total'
        }
        this.getSubLobAnalysisSummary()
      },
      initLecturerPage() {
        this.page.currentPage = 1;
        this.page.pageSize = this.search.size;
        this.search.current = 1;
      },
      initSubLobPage() {
        this.subLobPage.currentPage = 1;
        this.subLobPage.pageSize = this.search.size;
        this.searchSubLob.current = 1;
      },
      searchLecturerAnalysisChange() {
        this.initLecturerPage();
        this.getLecturerAnalysisSummary()
      },
      searchLecturerAnalysisReset() {
        this.search.lecturer = "";
        this.search.unionId = "";
        this.searchedLecturerDateRange = [];
        this.searchLecturerAnalysisChange();
      },
      searchSubLobAnalysisChange() {
        this.initSubLobPage();
        this.getSubLobAnalysisSummary()
      },
      searchSubLobAnalysisReset() {
        this.searchSubLob.organizedBy = "";
        this.searchedSubLobDateRange = [];
        this.searchSubLobAnalysisChange();
      },
      handleLecturerSortChange(val) {
        if (val.prop == "courseCount") {
          this.search.sortField = "courseCount"
        } else {
          this.search.sortField = ""
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortField = "courseCount"
          this.search.sortPolicy = "desc"
        }
        this.getLecturerAnalysisSummary()
      },
      handleLecturerCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getLecturerAnalysisSummary()
      },
      handleLecturerSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getLecturerAnalysisSummary()
      },
      handleSubLobSortChange(val) {
        if (val.prop == "courseCount") {
          this.searchSubLob.sortField = "courseCount"
        } else {
          this.searchSubLob.sortField = ""
        }
        if (val.order == 'ascending') {
          this.searchSubLob.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.searchSubLob.sortPolicy = "desc"
        } else {
          this.searchSubLob.sortField = "courseCount"
          this.searchSubLob.sortPolicy = "desc"
        }
        this.getSubLobAnalysisSummary()
      },
      handleSubLobCurrentChange(val) {
        this.subLobPage.currentPage = val
        this.searchSubLob.current = val
        this.getSubLobAnalysisSummary()
      },
      handleSubLobSizeChange(val) {
        this.subLobPage.pageSize = val
        this.subLobPage.currentPage = 1
        this.searchSubLob.size = val
        this.searchSubLob.current = 1
        this.getSubLobAnalysisSummary()
      },
      daysBetween(sDate1,sDate2){
        //Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
        var time1 = Date.parse(new Date(sDate1));
        var time2 = Date.parse(new Date(sDate2));
        var nDays = Math.abs(parseInt((time2 - time1)/1000/3600/24)) + 1;
        return nDays;
      },
      getLecturerAnalysisSummary() {
        let params = {
          current: this.search.current,
          size: this.search.size,
        }
        if (this.search.lecturer != "" && this.search.lecturer.trim() != "")
          params.lecturer = this.search.lecturer
        if (this.search.unionId != "" && this.search.unionId.trim() != "")
          params.unionId = this.search.unionId
        params.fromDate = this.searchedLecturerDateRange[0]
        params.toDate = this.searchedLecturerDateRange[1]
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else {
          params.sortField = "courseCount"
        }
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = "desc"
        }
        this.listLoading = true
        getActivityLecturerStatisticsSummaryData(params).then(response => {
          this.list = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.listLoading = false
        });
      },
      getSubLobAnalysisSummary() {
        let params = {
          current: this.searchSubLob.current,
          size: this.searchSubLob.size,
        }
        if (this.searchSubLob.organizedBy != "" && this.searchSubLob.organizedBy.trim() != "")
          params.organizedBy = this.searchSubLob.organizedBy
        params.fromDate = this.searchedSubLobDateRange[0]
        params.toDate = this.searchedSubLobDateRange[1]
        if (this.searchSubLob.sortField != "" && this.searchSubLob.sortField.trim() != "")
          params.sortField = this.searchSubLob.sortField
        else {
          params.sortField = "courseCount"
        }
        if (this.searchSubLob.sortPolicy != "" && this.searchSubLob.sortPolicy.trim() != "")
          params.sortPolicy = this.searchSubLob.sortPolicy
        else {
          params.sortPolicy = "desc"
        }
        this.subLobsListLoading = true
        getActivitySubLobStatisticsSummaryData(params).then(response => {
          this.subLobsList = this.formatData(response.data.data.records)
          this.subLobPage.total = response.data.data.total
          this.subLobsListLoading = false
        });
      },
      formatData(records) {
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.unionId && !record.totalScore) { record.totalScore = 0 }
            if (record.unionId && !record.averageScore) { record.averageScore = 0 }
            if (record.unionId && !record.totalParticipantCount) { record.totalParticipantCount = 0 }
            if (!record.unionId) { record.totalScore = '--'; record.averageScore = '--'; record.totalParticipantCount = '--' }
            if (!record.organizedBy) { record.organizedBy = "--" }
            if (!record.lecturer) { record.lecturer = "--" }
            if (!record.unionId) { record.unionId = "--" }
            if (!record.courseCount) { record.courseCount = 0 }
          })
        }
        return records
      },
      searchLecturerChange(query, done) {
        if (query.length < 3) return;
        let _this = this
        let lecturers = []
        let params = {
          nickname: query,
        }
        setTimeout(() => {
          getMembersByNickname(params).then(response => {
              if (response.status == 200) {
              lecturers = response.data.data
              _this.lecturers = []
              if (lecturers && lecturers.length > 0) {
                lecturers.forEach(function(lecturer, index) {
                  _this.lecturers.push( {value: lecturer.nickname + '(' + lecturer.unionId + ')', nickname: lecturer.nickname, unionId: lecturer.unionId, id: lecturer.memberId} )
                })
              }
              done(_this.lecturers)
            }
          }).catch(err => {
          })
        }, 500);
      },
      fetchSubLobList() {
        let params = {
          department: '',
        }
        getSubLobsByDepartment(params).then(response => {
            if (response.status == 200) {
            this.subLobList = response.data.data
          }
        }).catch(err => {
        })
      },
      searchSubLobChange(query, done) {
        if (query.length < 3) return;
        let _this = this
        let subLobList = []
        let params = {
          department: query,
        }
        setTimeout(() => {
          getSubLobsByDepartment(params).then(response => {
              if (response.status == 200) {
              subLobList = response.data.data
              _this.subLobList = []
              if (subLobList && subLobList.length > 0) {
                subLobList.forEach(function(organizedBy, index) {
                  _this.subLobList.push( { value: organizedBy, id: index } )
                })
              }
              done(_this.subLobList)
            }
          }).catch(err => {
          })
        }, 500);
      },
      handleLecturerSelect(item) {
        this.search.lecturer = item.nickname
        this.search.unionId = item.unionId
        this.searchLecturerAnalysisChange();
      },
      handleSubLobSelect(item) {
        this.searchSubLob.organizedBy = item.value
        this.searchSubLobAnalysisChange();
      },
      handleLecturerAnalysisExport() {
        let params = {}
        if (this.search.lecturer != "" && this.search.lecturer.trim() != "")
          params.lecturer = this.search.lecturer
        if (this.search.unionId != "" && this.search.unionId.trim() != "")
          params.unionId = this.search.unionId
        params.fromDate = this.searchedLecturerDateRange[0]
        params.toDate = this.searchedLecturerDateRange[1]
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else {
          params.sortField = "courseCount"
        }
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = "desc"
        }
        exportActivityLecturerStatisticsSummaryData(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLecturerAnalysisByLoading = true
            this.exportLecturerAnalysisName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLecturerAnalysisByLoading = false
        this.exportLecturerAnalysisName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
      handleSubLobAnalysisExport() {
        let params = {}
        if (this.searchSubLob.organizedBy != "" && this.searchSubLob.organizedBy.trim() != "")
          params.organizedBy = this.searchSubLob.organizedBy
        params.fromDate = this.searchedSubLobDateRange[0]
        params.toDate = this.searchedSubLobDateRange[1]
        if (this.searchSubLob.sortField != "" && this.searchSubLob.sortField.trim() != "")
          params.sortField = this.searchSubLob.sortField
        else {
          params.sortField = "courseCount"
        }
        if (this.searchSubLob.sortPolicy != "" && this.searchSubLob.sortPolicy.trim() != "")
          params.sortPolicy = this.searchSubLob.sortPolicy
        else {
          params.sortPolicy = "desc"
        }
        exportActivitySubLobStatisticsSummaryData(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportSubLobAnalysisByLoading = true
            this.exportSubLobAnalysisName = "导出中..."
            exporting(response.data.data, this.exportOrganizedByCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportOrganizedByCallback(result) {
        this.exportSubLobAnalysisByLoading = false
        this.exportSubLobAnalysisName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.activity-party-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-date {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
.grid-content-select {
  width: 96%;
}
</style>
